import {Text, Scroll, Box} from 'platform/foundation';

import {useLayoutEffect, useRef} from 'react';

import {inc} from 'ramda';

import {UseDocumentPreviewReturnType} from '../types/UseDocumentPreviewReturnType';
import {DocumentPreviewThumbnailsItem} from './DocumentPreviewThumbnailsItem';

interface DocumentPreviewThumbnailsProps {
  documentPreview: UseDocumentPreviewReturnType;
}

export function DocumentPreviewThumbnails(props: DocumentPreviewThumbnailsProps) {
  const thumbnailsRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const handle = requestAnimationFrame(() => {
      if (thumbnailsRef.current?.children?.[props.documentPreview.state.activeIndex]) {
        thumbnailsRef.current.children[props.documentPreview.state.activeIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });

    return () => cancelAnimationFrame(handle);
  }, [props.documentPreview.state.activeIndex]);

  return (
    <>
      <Box flexShrink={0}>
        <Text size="xSmall">{`${inc(props.documentPreview.state.activeIndex)} / ${props.documentPreview.state.pages.length}`}</Text>
      </Box>

      <Scroll auto hasHiddenScrollBars flex={1}>
        <Box ref={thumbnailsRef} paddingBottom={2}>
          {props.documentPreview.state.pages.map((documentPage, documentPageIndex) => (
            <DocumentPreviewThumbnailsItem
              key={documentPage.id}
              isActive={props.documentPreview.state.activeIndex === documentPageIndex}
              documentPage={documentPage}
              documentPreview={props.documentPreview}
            />
          ))}
        </Box>
      </Scroll>
    </>
  );
}
